<template>
  <el-container class="full-fill">
    <el-aside class="menu" width="auto">
      <Menu :active-menu-path="activeTabPath" :collapse="menuCollapse" />
    </el-aside>

    <el-container>
      <el-header class="header">
        <Header :menu-collapse.sync="menuCollapse" @SwitchOrg="switchOrg" />
      </el-header>
      <el-main class="content">
        <el-tabs
          v-model="activeTabName"
          @tab-remove="removeTab"
          @tab-click="clickTab"
        >
          <el-tab-pane
            v-for="item in tabs"
            :key="item.name"
            :label="item.title"
            :name="item.name"
            :closable="item.name != 'Home'"
          />
        </el-tabs>
        <keep-alive :include="shouldKeepAlive">
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Menu from "@components/Menu.vue";
import Header from "@components/Header.vue";

export default {
  components: {
    Menu,
    Header,
  },
  data: function () {
    return {
      menuCollapse: false,
      activeTabName: null,
      activeTabPath: null,
      tabs: [],
    };
  },
  computed: {
    shouldKeepAlive: function () {
      return this.tabs.map((x) => x.name);
    },
  },
  mounted() {},
  provide: function () {
    return {
      getMap: this.removeTab,
    };
  },
  methods: {
    setActiveTab: function (name, go = false) {
      const tab = this.tabs.filter((x) => x.name == name)[0];
      this.activeTabName = tab.name;
      this.activeTabPath = tab.path;
      if (go) {
        this.$router.push(tab.path);
      }
    },

    addTab: function (targetRoute) {
      let {
        fullPath,
        meta: { name, title },
      } = targetRoute;

      if (typeof title === "function") {
        title = title(targetRoute.params);
      }

      const tabs = this.tabs;

      for (let i = 0; i < tabs.length; i++) {
        const tab = tabs[i];
        if (tab.name == name) {
          if (title != tab.title) {
            tab.title = title;
          }
          if (tab.path != fullPath) {
            tab.path = fullPath;
          }
          this.setActiveTab(name);
          return;
        }
      }

      const newTab = {
        title: title,
        name: name,
        path: fullPath,
      };
      tabs.push(newTab);
      this.setActiveTab(newTab.name);
    },
    removeTab: function (targetName) {
      const tabs = this.tabs;
      let activeTabName = this.activeTabName;
      const oldActiveTabName = activeTabName;

      if (activeTabName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeTabName = nextTab.name;
            }
          }
        });
      }

      this.tabs = tabs.filter((tab) => tab.name !== targetName);

      if (activeTabName != oldActiveTabName) {
        this.setActiveTab(activeTabName, true);
      }
    },
    clickTab: function ({ name }) {
      this.setActiveTab(name, true);
    },
    switchOrg: function () {
      const firstTab = this.tabs[0];
      this.tabs = [firstTab];
      if (firstTab.name != this.activeTabName) {
        this.setActiveTab(firstTab.name, true);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.addTab(to);
    });
  },
  beforeRouteUpdate: function (to, from, next) {
    this.$store.commit("setTabName", to.meta.name);
    this.addTab(to);
    next();
  },
};
</script>

<style lang="less" scoped>
.menu {
  background: #304156;
}

.header {
  height: auto !important;
  padding: 0px;
  box-shadow: 1px 1px 5px #888888;
}

.content {
  padding: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden; // 加了这个，不知道有没有副作用
  & > *:last-child {
    flex: auto;
  }
}
</style>
